import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'cfe-hero-banner',
	templateUrl: './hero-banner.component.html',
	styleUrls: ['./hero-banner.component.scss']
})
export class HeroBannerComponent implements OnInit {
	constructor() {}

	ngOnInit() {}
}
